import * as tslib_1 from "tslib";
import * as React from 'react';
import { Input } from 'reactstrap';
/**
 * Input wrapper that provides autosizing when used with a textarea.
 *
 * @param props
 */
export var ElasticInput = function (props) {
    var className = props.className, onInput = props.onInput, type = props.type, rest = tslib_1.__rest(props, ["className", "onInput", "type"]);
    var _a = React.useState(undefined), calculatedHeight = _a[0], setCalculatedHeight = _a[1];
    var inputRef = React.useRef(null);
    // Calcualte the best height for input.
    var resizeToBestHeight = React.useCallback(function (target) {
        // Reset the height and then set it based on the scrollHeight.
        target.style.height = '';
        var newHeight = target.scrollHeight + 10; /* The 10 provides a nice buffer to avoid flicker */
        ;
        target.style.height = newHeight + "px";
        // Store the height for the next render.
        setCalculatedHeight(newHeight);
    }, [setCalculatedHeight]);
    // Calculate height when the user provides input to the control.
    var onInputWrapper = React.useCallback(function (event) {
        resizeToBestHeight(event.currentTarget);
        // Pass on the input event.
        if (onInput) {
            onInput(event);
        }
    }, [resizeToBestHeight, onInput]);
    // Calculate the height when we mount or are first displayed on screen with a non-zero height.
    React.useEffect(function () {
        if (!calculatedHeight && inputRef.current && inputRef.current.scrollHeight > 0) {
            resizeToBestHeight(inputRef.current);
        }
    }, [inputRef.current, calculatedHeight, resizeToBestHeight]);
    return (React.createElement(Input, tslib_1.__assign({ innerRef: inputRef, type: type || 'textarea', className: "elastic " + (className || '') }, rest, { onInput: onInputWrapper, style: { height: calculatedHeight } })));
};
//# sourceMappingURL=ElasticInput.js.map